<template>
<div class="row m-0 p-0" v-if="modeBoxOptions.title">
  <div v-for="(item, index) in items" :key="index" class="m-0 p-0" :class="modeBoxOptions.boxCantFilas">
    <router-link :to="interpolatePath(item)">
      <div class="caja p-3 m-2 sombra rounded" :style="`border-top: ${modeBoxOptions.borderBox}px solid ${modeBoxOptions.colorAcentBox} !important`">
        <h5 class="text-muted"> {{ text(item, modeBoxOptions.category) }} </h5>
        <h2 class="text-secondary"> {{ text(item, modeBoxOptions.title) }} </h2>
        <div class="text-secondary mb-2">{{ text(item, modeBoxOptions.content) }}</div>
      </div>
    </router-link>
  </div>
</div>
</template>

<script>
import _ from 'lodash'
import lmToasts from '@/mixins/lmToasts.js'
export default {
  name: 'Box',
  mixins: [lmToasts],
  data () {
    return {
      error: false,
      myToast: null
    }
  },
  props: {
    items: {
      type: [Array, String],
      default: () => [],
      required: true
    },
    modeBoxOptions: {
      type: [Object],
      default: () => ({}),
      required: true
    }
  },
  watch: {
    'modeBoxOptions.path': {
      immediate: false,
      deep: false,
      // Chequea que se escriben correctamente las propiedades en el path
      handler (val, oldVal) {
        // función que busca las coincidencias en los key
        var traverse = function (item, keys) {
          return keys.split('.').reduce(function (cur, key) {
            return cur[key]
          }, item)
        }
        // Saca las variables del path y los coloca en un array
        const path = this.modeBoxOptions.path
        // eslint-disable-next-line no-useless-escape
        const regExp = /[^{\}]+(?=})/g
        const match = path.match(regExp)

        // Hace un for por el array de variables
        // Si encuenta una variable que no existe, setea error a true
        let res = null
        _.forEach(match, (value, key) => {
          res = traverse(this.items[0], match[key])
          if (!res) {
            this.error = true
            return false
          } else {
            this.error = false
          }
        })
        // Si hay un error, muestra el toast de error, sino el de éxito
        // El setTimeout da tiempo al usuario que termine de escribir para dar el mensaje
        if (this.error) {
          clearTimeout(this.myToast)
          this.myToast = setTimeout(() => {
            this.lmToastDangerMessage('Lo sentimos pero ha referenciado propiedades que no pertenecen a este listado.', 'Error en variable de Ruta')
          }, 2000)
        } else {
          clearTimeout(this.myToast)
          this.myToast = setTimeout(() => {
            this.$bvToast.hide(1)
            this.lmToastSuccessMessage('Las propiedades son correctas.', 'Ruta')
          }, 2000)
        }
      }
    }
  },
  methods: {
    // Interpola el path con las variables que vienen entre llaves.
    // Ej: remplaza {{role.id}} por el contenido de item.role.id
    interpolatePath (item) {
      try {
        _.templateSettings.interpolate = /{{([\s\S]+?)}}/g
        const template = _.template(this.modeBoxOptions.path)
        const compiled = template({ ...item })
        return compiled
      } catch (error) {
        // console.log('error', error)
        return ''
      }
    },
    // Chequea si el item es un objeto o un string
    // si es un texto retorna el string
    // si es un objeto retorna res?.name
    text (item, field) {
      let res = item[field]
      if (typeof res === 'object') {
        res = res?.name || ''
      }
      return res
    }
  }
}
</script>

<style lang="sass" scoped>
a
  color: #6c757d
a:hover
  color: #6c757d
.sombra
  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.15)
  transition: box-shadow 0.23s ease-out;
.sombra:hover
  box-shadow: 0 0.3rem 0.5rem rgba(0, 0, 0, 0.2)
</style>
